import React from 'react';

export const Spinner = ({ label }) => (
  <>
    <span className="spinner" aria-hidden="true"></span>
    {label ? <span>{label}</span> : null}
  </>
);

/** Bloco padrão para carregando / vazio / erro. */
const StateBlock = ({ icon = 'bi-hourglass-split', title, description, children, busy = false }) => (
  <div className="surface-card state-block" role="status" aria-busy={busy}>
    <span className="state-block__icon" aria-hidden="true">
      {busy ? <span className="spinner"></span> : <i className={`bi ${icon}`}></i>}
    </span>
    {title && <h2 className="section-subtitle">{title}</h2>}
    {description && <p>{description}</p>}
    {children}
  </div>
);

export default StateBlock;
